export default __webpack_public_path__ + "static/media/mainImage1.6a9c86ff.jpg";